export default "__VITE_ASSET__DtongfAL__"